import React from "react";
import { Link } from "react-router-dom";
import "./ServicesDetail.css";
import preopImg from "../../assets/images/preoperative.jpg";

function PreoperativePrehab() {
  return (
    <div className="service-detail-container">
      <div className="service-detail-image">
        <img src={preopImg} alt="Preoperative Prehabilitation" />
      </div>
      <div className="service-detail-content">
        <h2>Preoperative Prehabilitation</h2>
        <p>
          Preoperative prehab helps prepare your body for an upcoming surgery by
          increasing strength, improving flexibility, and optimizing overall
          fitness. This can lead to faster post-surgical recovery.
        </p>
        <p>
          <strong>When is it needed?</strong>
          If you have a scheduled orthopaedic surgery, joint replacement, or any
          significant procedure that impacts mobility, prehab can set a strong
          foundation for a successful outcome.
        </p>
        <ul className="service-bullet-list">
          <li>Pre-surgery conditioning and strengthening</li>
          <li>Cardiovascular endurance improvement</li>
          <li>Education on post-surgical exercises</li>
        </ul>
        <p>
          By starting therapy before your surgery, you’ll enter the operating room
          in better shape, potentially reducing complications and speeding up
          rehabilitation.
        </p>

        <Link to="/contact" className="service-cta-button">
          Contact Us to Learn More
        </Link>
      </div>
    </div>
  );
}

export default PreoperativePrehab;
